import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { client } from "@/data/client";
import { KpiCard } from "@/components/KpiCard";
import { MultiSeriesChart } from "@/components/MultiSeriesChart";
import { formatPct } from "@/lib/utils";
import { CallDaySection } from "@/pages/dashboard-sections/CallDaySection";

type Period = { periodStart: string; periodEnd: string };

const SERIES = [
  { key: "total", name: "Ligações", color: "hsl(var(--chart-2))" },
  { key: "uniqueContacts", name: "Contatos únicos", color: "hsl(var(--chart-1))" },
  { key: "answered", name: "Atendidas", color: "hsl(var(--chart-3))" },
  { key: "connections", name: "Conexões", color: "hsl(var(--chart-4))" },
];

export function CallsTab({ period }: { period: Period }) {
  const [selectedDay, setSelectedDay] = useState<string | null>(null);

  const kpis = useQuery({ queryKey: ["call-kpis", period], queryFn: () => client.getCallKpis(period) });
  const daily = useQuery({ queryKey: ["call-daily", period], queryFn: () => client.getCallDaily(period) });

  const data = kpis.data;

  const handleChartClick = (payload: Record<string, unknown>) => {
    const date = payload?.date;
    if (typeof date === "string") setSelectedDay(date);
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-4 gap-5">
        <KpiCard
          label="Ligações"
          value={data ? data.total.toLocaleString("pt-BR") : "—"}
          caption="volume total de tentativas"
          accent="hsl(var(--chart-2))"
        />
        <KpiCard
          label="Contatos únicos"
          value={data ? data.uniqueContacts.toLocaleString("pt-BR") : "—"}
          caption="leads distintos contactados"
          accent="hsl(var(--chart-1))"
        />
        <KpiCard
          label="Ligações atendidas"
          value={data ? data.answered.toLocaleString("pt-BR") : "—"}
          caption={data ? `${formatPct(data.answerRate, 1)} taxa de atendimento` : "—"}
          accent="hsl(var(--chart-3))"
        />
        <KpiCard
          label="Conexões"
          value={data ? data.connections.toLocaleString("pt-BR") : "—"}
          caption="conversas com avanço comercial"
          accent="hsl(var(--chart-4))"
        />
      </div>

      <MultiSeriesChart
        data={daily.data ?? []}
        series={SERIES}
        title="Visão geral"
        subtitle="Volume diário · clique num dia para ver todas as ligações realizadas"
        defaultMode="line"
        allowModeToggle={false}
        onPointClick={handleChartClick}
        pulseAllSeries
      />

      <CallDaySection date={selectedDay} onClear={() => setSelectedDay(null)} />
    </div>
  );
}
